/**
 * Created by lizj on 2018/5/29.
 */

/**
 * 弹窗更改邮箱
 * isShowUpdateEmail: true | false 显示 | 隐藏 弹窗
 * email 把通过的邮箱值传出去
 */

;(function () {
    updateEmailCtrl.$inject = ['$scope', '$timeout'];
    angular
        .module('DSSXAPP')
        .component('updateEmail', {
            template:'<div class="update-email"><div class="input-email"><span class="ib">请输入邮箱 ：</span> <input type="text" ng-model="vm.d.email"></div><div class="affirm-email"><span class="ib">再次确认邮箱 ：</span> <input type="text" ng-model="vm.d.affirmEmail"></div><div class="submitBox"><input class="btn" value="提交" ng-click="vm.f.sub()"></div></div>',
            bindings: {
                isShowUpdateEmail: "=",
                email: '&'
            },
            controllerAs: 'vm',
            controller: updateEmailCtrl
        });

    function updateEmailCtrl($scope, $timeout) {
        this.$onInit = onInit();

        var vm = this;
        var emailIndex = null;
        //邮箱正则验证
        var emailReg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");

        vm.d = {
            email: '',
            affirmEmail: ''
        };

        vm.f = {
            close: close,
            sub: sub
        };

        function onInit() {
            initScopeWatch();
        }

        function initScopeWatch() {
            $scope.$watch('vm.isShowUpdateEmail', function (nv, ov) {
                if (nv) {
                    emailIndex = layer.open({
                        type: 1,
                        offset: '300px',
                        area: '320px',
                        resize: false,
                        title: "修改邮箱",
                        scrollbar: false,
                        content: $('.update-email'),
                        cancel: function () {
                            close();
                        },
                        success: function (layero, index) {

                        }
                    });
                }
            })
        }

        function close() {
            changeUpdateEmailSta();
            layer.close(emailIndex);
        }

        //改变更改邮箱状态
        function changeUpdateEmailSta() {
            $timeout(function () {
                vm.isShowUpdateEmail = false;
            })
        }

        //提交表单
        function sub() {
            var email = vm.d.email;
            var affirmEmail = vm.d.affirmEmail;

            if (!email || !affirmEmail) {
                layer.msg("请填写邮箱", {icon: 2});
                return;
            }

            if (!emailReg.test(email) || !emailReg.test(affirmEmail)) {
                layer.msg("邮箱格式不正确", {icon: 2});
                return;
            }

            if (email !== affirmEmail) {
                layer.msg("两次邮箱不一致", {icon: 2});
                return;
            }

            close();
            vm.email({
                $event: {
                    email: email
                }
            })
        }
    }
})();